import { render, staticRenderFns } from "./KeepOut.vue?vue&type=template&id=23a1289b&scoped=true"
import script from "./KeepOut.vue?vue&type=script&lang=js"
export * from "./KeepOut.vue?vue&type=script&lang=js"
import style0 from "./KeepOut.vue?vue&type=style&index=0&id=23a1289b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1289b",
  null
  
)

export default component.exports